import React, { Fragment, useState, useEffect, useContext, useMemo } from "react";
import CustomContext from "../../_helper/Customizer";
import { menuPathMatches, sectionMatchesPath } from "./Menu";
import { enrichMenuWithPermissions } from "../../constants/menuAccess";
import { isSuperAdmin } from "../../constants/credoraRoles";
import { getStoredUser } from "../../api/auth";
import { useCredoraMenu } from "../../hooks/useCredoraMenu";
import CustomizerContext from "../../_helper/Customizer";
import SidebarIcon from "./SidebarIcon";
import SidebarLogo from "./SidebarLogo";
import SidebarMenu from "./SidebarMenu";

const Sidebar = (props) => {
  const customizer = useContext(CustomContext);
  const { toggleIcon } = useContext(CustomizerContext);
  const id = window.location.pathname.split("/").pop();
  const defaultLayout = Object.keys(customizer.layout);

  const layout = id ? id : defaultLayout;
  // eslint-disable-next-line
  const { menu: filteredMenu } = useCredoraMenu();
  const fullMenu = useMemo(() => enrichMenuWithPermissions(), []);
  const sidebarMenu = isSuperAdmin(getStoredUser()) ? fullMenu : filteredMenu;
  const [mainmenu, setMainMenu] = useState({ mainmenu: sidebarMenu });

  const [width, setWidth] = useState(0);

  const handleScroll = () => {
    if (window.scrollY > 400) {
      // if (
      //   customizer.settings.sidebar.type.split(' ').pop() ===
      //   'material-type' ||
      //   customizer.settings.sidebar.type.split(' ').pop() ===
      //   'advance-layout'
      // )
      document.querySelector(".sidebar-main").className = "sidebar-main hovered";
    } else {
      if (document.getElementById("sidebar-main")) document.querySelector(".sidebar-main").className = "sidebar-main";
    }
  };

  useEffect(() => {
    document.querySelector(".left-arrow").classList.add("d-none");
    window.addEventListener("resize", handleResize);
    handleResize();
    setMainMenu({ mainmenu: isSuperAdmin(getStoredUser()) ? fullMenu : filteredMenu });
  }, [filteredMenu, fullMenu]);

  useEffect(() => {
    const currentUrl = window.location.pathname;
    const baseMenu = isSuperAdmin(getStoredUser()) ? fullMenu : filteredMenu;
    const menuCopy = baseMenu.map((g) => ({
      ...g,
      Items: g.Items.map((s) => ({
        ...s,
        children: s.children?.map((c) => ({ ...c })),
      })),
    }));
    menuCopy.forEach((items) => {
      items.Items.forEach((section) => {
        if (sectionMatchesPath(section, currentUrl)) {
          section.active = true;
          section.children?.forEach((child) => {
            if (menuPathMatches(currentUrl, child.path)) {
              child.active = true;
            }
            child.children?.forEach((sub) => {
              if (menuPathMatches(currentUrl, sub.path)) {
                sub.active = true;
                section.active = true;
              }
            });
          });
        }
      });
    });
    setMainMenu({ mainmenu: menuCopy });
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [layout, filteredMenu, fullMenu]);

  const handleResize = () => {
    setWidth(window.innerWidth - 500);
  };

  const activeClass = () => {
    if (window.innerWidth <= 991) {
      document.querySelector(".bg-overlay1")?.classList.add("active");
    }
  };

  const setNavActive = (item) => {
    const baseMenu = mainmenu.mainmenu || (isSuperAdmin(getStoredUser()) ? fullMenu : filteredMenu);
    const willOpen = !item.active;
    const groups = baseMenu.map((g) => ({
      ...g,
      Items: g.Items.map((s) => {
        // Reference compare against the live state object BEFORE we copy it.
        const isTarget = s === item;
        return {
          ...s,
          active: isTarget ? willOpen : false,
          children: s.children?.map((c) => ({ ...c })),
        };
      }),
    }));
    if (window.innerWidth <= 991) {
      document.querySelector(".bg-overlay1")?.classList.remove("active");
    }
    if (willOpen) {
      document.querySelector(".sidebar-links")?.classList.add("active");
    }
    setMainMenu({ mainmenu: groups });
  };

  const closeOverlay = () => {
    document.querySelector(".bg-overlay1").classList.remove("active");
    document.querySelector(".sidebar-links").classList.remove("active");
  };

  return (
    <Fragment>
      <div className={`sidebar-wrapper ${toggleIcon ? "close_icon" : ""}`} sidebar-layout="stroke-svg">
        <SidebarIcon />
        <SidebarLogo />
        {/* sidebartoogle={sidebartoogle} */}
        <SidebarMenu
          menuGroups={mainmenu.mainmenu || sidebarMenu}
          setMainMenu={setMainMenu}
          props={props}
          setNavActive={setNavActive}
          activeClass={activeClass}
          width={width}
        />
      </div>
      <div
        className="bg-overlay1"
        onClick={() => {
          closeOverlay();
        }}
      />
    </Fragment>
  );
};

export default Sidebar;
